import { createSlice } from '@reduxjs/toolkit';
import {
  createBudgetRevenue,
  fetchAllBudgetRevenues,
  fetchBudgetRevenueById,
  updateBudgetRevenue,
  deleteBudgetRevenue
} from './budgetRevenueActions';
import { BudgetRevenueState } from './budgetRevenueTypes';

const initialState: BudgetRevenueState = {
  revenues: [],
  selectedRevenue: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const budgetRevenueSlice = createSlice({
  name: 'budgetRevenue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createBudgetRevenue.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createBudgetRevenue.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.revenues.push(action.payload.data);
      })
      .addCase(createBudgetRevenue.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllBudgetRevenues.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllBudgetRevenues.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.revenues = action.payload.data;
      })
      .addCase(fetchAllBudgetRevenues.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchBudgetRevenueById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchBudgetRevenueById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRevenue = action.payload.data;
      })
      .addCase(fetchBudgetRevenueById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateBudgetRevenue.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateBudgetRevenue.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        // const index = state.revenues.findIndex(r => r.budget_revenue_id === action.payload.id);
        // if (index !== -1) {
        //   state.revenues[index] = { ...action.payload.data, budget_revenue_id: action.payload.id };
        // }
      })
      .addCase(updateBudgetRevenue.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deleteBudgetRevenue.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteBudgetRevenue.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.revenues = state.revenues.filter(r => r.budget_revenue_id !== action.payload);
      })
      .addCase(deleteBudgetRevenue.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default budgetRevenueSlice.reducer;
